<template>
  <div data-test-id="StartPage" class="ems-page">
    <NavBar class="mb-2">
      <template #left>
        <SettingsLink />
      </template>
      <template #center>
        <b>TigerConnect EMS</b>
      </template>
      <template #right>
        <Messages />
      </template>
    </NavBar>

    <b-container v-if="user">
      <b-row class="bottom-bordered" data-test-id="WelcomeRow">
        <div class="col text-left">
          <span class="text-white">Welcome {{ user.displayName }}</span>
        </div>
        <div class="col text-right">
          <Logout />
        </div>
      </b-row>
      <b-row class="bottom-bordered">
        <div class="col text-left">
          <span class="text-white">Shift Ends</span>
        </div>
        <div class="col text-right">
          <div
            class="text-red float-right"
            role="button"
            tabindex="0"
            data-test-id="shiftButton"
            @click="goToShift"
            @keydown.enter="goToShift"
          >
            {{ autoLogoutTime || "Choose Time" }}
          </div>
        </div>
      </b-row>
      <b-row class="bottom-bordered" data-test-id="TeamRow">
        <div class="col text-left">
          <span class="text-white">Team</span>
        </div>
        <div class="col text-right">
          <span class="text-red" data-test-id="teamsButton" role="button" tabindex="0" @click="onTeamClick">
            {{ selectedTeam.name }}
          </span>
        </div>
      </b-row>
      <b-row class="bottom-bordered" data-test-id="TruckRow">
        <div class="col text-left">
          <span class="text-white">Truck</span>
        </div>
        <div class="col text-right">
          <span class="text-red" data-test-id="trucksButton" role="button" tabindex="0" @click="onTruckClick">
            {{ selectedTruck.name }}
          </span>
        </div>
      </b-row>
      <CaseTransferRequest />

      <b-row v-if="aiEnhancedProtocolsEnabled" class="bottom-bordered">
        <div class="col text-left">
          <span class="text-white">Protocols</span>
        </div>
        <div class="col text-right">
          <Protocol :twiage-case="null">
            <div class="text-right">
              <span class="text-red" role="button" tabindex="0">Ask Question</span>
            </div>
          </Protocol>
        </div>
      </b-row>

      <b-row class="mt-2 justify-content-center">
        <b-col class="col-10 col-sm-8 col-md-6 col-lg-6 w-50">
          <img src="@/App/assets/logo.png" class="twiage-image image-height" />
          <h5 class="tag-line">Accelerate Emergency Care</h5>
          <case-feedback-modal v-if="shouldRequestFeedback" />
          <b-button
            variant="danger"
            class="background-red mt-5 col-12 border-0"
            data-test-id="startCaseButton"
            @click="onStartCase"
          >
            <b>START CASE</b>
          </b-button>
        </b-col>
      </b-row>
      <ContactInfo />
    </b-container>
  </div>
</template>

<script lang="ts">
import { mapActions, mapGetters } from "vuex";
import NavBar from "@/App/components/NavBar.vue";
import Messages from "@/App/components/Messages.vue";
import Logout from "@/App/components/Logout.vue";
import ContactInfo from "@/App/components/ContactInfo.vue";
import SettingsLink from "@/Start/components/SettingsLink.vue";
import CaseTransferRequest from "@/Start/components/CaseTransferRequest.vue";
import Protocol from "@/Protocol/Protocol.vue";
import Vue from "vue";
import CaseFeedbackModal from "@/CaseFeedback/ui/CaseFeedbackModal.vue";

export default Vue.extend({
  name: "Start",
  components: {
    CaseFeedbackModal,
    Protocol,
    NavBar,
    Messages,
    Logout,
    ContactInfo,
    SettingsLink,
    CaseTransferRequest,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("Login", ["user", "autoLogoutTime", "authToken"]),
    ...mapGetters("TeamSelection", ["selectedTeam"]),
    ...mapGetters("TruckSelection", ["selectedTruck"]),
    ...mapGetters("CaseFeedback", ["shouldRequestFeedback"]),
    aiEnhancedProtocolsEnabled() {
      return this.$store.getters["Login/user"]?.features?.find((feature) => feature.name === "aiEnhancedProtocols")
        ?.enabled;
    },
  },
  mounted() {
    this.$store.dispatch("CaseFeedback/onViewLoaded");
  },
  methods: {
    ...mapActions("Case", ["startCase"]),
    ...mapActions("Login", ["isTokenValid", "validateToken"]),
    goToShift() {
      this.$router.push({ name: "shift" });
    },
    onTeamClick() {
      this.$router.push({ name: "team-selection" });
    },
    onTruckClick() {
      this.$router.push({ name: "truck-selection" });
    },
    onStartCase() {
      const isTokenValid = this.isTokenValid() as unknown as boolean;
      if (isTokenValid) {
        this.startCase();
        this.$router.push({ name: "case" });
      } else {
        this.validateToken();
      }
    },
  },
});
</script>

<style>
.text-red {
  color: red;
}
.background-red {
  background-color: red;
  margin-bottom: 10px;
}
.bottom-bordered::after {
  content: "";
  display: block;
  width: 95%;
  border-bottom: 1px solid #111;
  margin: 0.5em auto;
}

@media screen and (min-width: 601px) {
  .image-height {
    height: 100px;
  }
}
/* On screens that are 600px or less, set the background color to olive */
@media screen and (max-width: 600px) {
  .image-height {
    height: 75px;
  }
}
.twiage-image {
  margin-bottom: 1.5rem !important;
}
.tag-line {
  font-weight: 300 !important;
  font-size: 1rem !important;
}
.small-tag-line {
  margin-top: 10px;
}
</style>
